import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import {DropDetailsPage as Page} from '@aboutyou/legacy-desktop/src/app/pages/Drops';
import {redialDropDetails} from '@aboutyou/legacy-desktop/src/app/pages/Drops/redial';

const PageWithRedial = redial.provideHooks(redialDropDetails)(Page);

export const DropDetailPage = withLegacyProviders(PageWithRedial);
